import {Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {Component, inject, OnDestroy, OnInit} from '@angular/core';

import {CurrentUser} from "@numizmat/services-models/account";
import {CurrentUserStateService} from "@numizmat/services/account";
import {OwnProfileComponent} from "@numizmat/pages/profile-page/components/own-profile/own-profile.component";
import {
  ForeignProfileComponent
} from "@numizmat/pages/profile-page/components/foreign-profile/foreign-profile.component";

@Component({
  selector: 'nz-profile-page',
  standalone: true,
  imports: [
    OwnProfileComponent,
    ForeignProfileComponent
  ],
  templateUrl: './profile-page.component.html',
  styleUrl: './profile-page.component.scss'
})
export class ProfilePageComponent implements OnInit, OnDestroy {
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private currentUserStateService: CurrentUserStateService = inject(CurrentUserStateService);

  private subs: Subscription = new Subscription();

  protected routeUserId?: string;
  protected currentUser!: CurrentUser;

  public ngOnInit(): void {
    this.getRouteUserId();
    this.getCurrentUser();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private getRouteUserId(): void {
    const subscription: Subscription = this.activatedRoute.paramMap.subscribe(params => {
      this.routeUserId = params.get('id') || '';
    });
    this.subs.add(subscription);
  }

  private getCurrentUser(): void {
    const subscription: Subscription = this.currentUserStateService.getCurrentUser().subscribe({
      next: (currentUser: CurrentUser) => {
        this.currentUser = currentUser;
      }
    });
    this.subs.add(subscription);
  }
}
